import axios from 'axios';

const api = axios.create({ baseURL: String(process.env.REACT_APP_MONOLITH_BASE_URL) });

export default api;
